import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { ReactElement } from "react";

export const Field = ({
  className,
  ...props
}: { className?: string } & Omit<
  Headless.FieldProps,
  "as" | "className"
>): ReactElement => (
  <Headless.Field
    {...props}
    className={clsx(
      className,
      "[&>[data-slot=label]+[data-slot=control]]:mt-3",
      "[&>[data-slot=label]+[data-slot=description]]:mt-1",
      "[&>[data-slot=description]+[data-slot=control]]:mt-3",
      "[&>[data-slot=control]+[data-slot=description]]:mt-3",
      "[&>[data-slot=control]+[data-slot=error]]:mt-3",
      "[&>[data-slot=label]]:font-medium",
    )}
  />
);
